import React, { Component, Fragment } from "react";

export default class Hire extends Component {
  render() {
    return (
      <Fragment>
        <h1>Hire Me</h1>
        <h1>I'm great with H1 tags</h1>
      </Fragment>
    );
  }
}
